export const PURCHASEDETAIL_LOADING = "PURCHASEDETAIL_LOADING";
export const PURCHASEDETAIL_RESET = "PURCHASEDETAIL_RESET";
export const GET_PURCHASEDETAIL = "GET_PURCHASEDETAIL";
export const GET_PURCHASEDETAIL_SUCCESS = "GET_PURCHASEDETAIL_SUCCESS";
export const GET_PURCHASEDETAIL_FAIL = "GET_PURCHASEDETAIL_FAIL";
export const DELETE_PURCHASEDETAIL = "DELETE_PURCHASEDETAIL"
export const DELETE_PURCHASEDETAIL_SUCCESS = "DELETE_PURCHASEDETAIL_SUCCESS"
export const DELETE_PURCHASEDETAIL_FAIL = "DELETE_PURCHASEDETAIL_FAIL"
export const UPDATE_PURCHASEDETAIL = "UPDATE_PURCHASEDETAIL"
export const UPDATE_PURCHASEDETAIL_SUCCESS = "UPDATE_PURCHASEDETAIL_SUCCESS"
export const UPDATE_PURCHASEDETAIL_FAIL = "UPDATE_PURCHASEDETAIL_FAIL"
export const ADD_NEW_PURCHASEDETAIL = "ADD_NEW_PURCHASEDETAIL"
export const ADD_PURCHASEDETAIL_SUCCESS = "ADD_PURCHASEDETAIL_SUCCESS"
export const ADD_PURCHASEDETAIL_FAIL = "ADD_PURCHASEDETAIL_FAIL"